import { api } from "@api/api";
import { AgreementIntegrationConfig } from "@modules/erpIntegrations/types";
import { ConfigFormValues } from "@modules/erpIntegrations/validations";

export async function createConfigService(
  data: ConfigFormValues
): Promise<AgreementIntegrationConfig> {
  const { data: config } = await api.post<AgreementIntegrationConfig>(
    "/v1/agreement_integration_config_admin/",
    {
      agreement: data.agreement,
      integration: data.integration,
      active: data.active ?? true,
      credentials: data.credentials ?? {},
      test_document: (data.test_document ?? "").replace(/\D/g, ""),
      access_token: data.access_token ?? "",
      ...(data.plan_map_option != null ? { plan_map_option: data.plan_map_option } : {}),
    }
  );

  return config;
}
